import Button from 'components/atoms/Button';
import Footer from 'components/molecules/Footer';
import { BUTTON_NAMES } from 'constant/button-names';
import { useConfig } from 'context/app-config';
import useOrderStep from 'packages/shared/newOrder/hooks/useOrderStep';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useShowEstimator } from 'store/cart-estimator';
import styled from 'styled-components';

import PricingButtonWithEstimator from './PricingButtonWithEstimator';

const StyledContainer = styled.div`
  display: flex;
`;

const StyledPlaceNewOrderListButton = styled(Button)`
  margin-top: 0px !important;
  background-color: ${({ theme }) => theme.components.pages.home?.placeOrderFooter?.backgroundColor};
  border-color: ${({ theme }) => theme.components.pages.home?.placeOrderFooter?.borderColor};
  color: ${({ theme }) => theme.components.pages.home?.placeOrderFooter?.textColor};
  font-size: 1rem;
  font-style: normal;
  line-height: 24px;
  font-weight: ${({ theme }) => theme.components.pages.home?.placeOrderFooter?.fontWeight ?? '700'};
  &:hover,
  &:focus,
  &:active,
  &.btn-primary:not(:disabled):not(.disabled):active {
    background-color: ${({ theme }) => theme.components.pages.home?.placeOrderFooter?.backgroundColor};
    border-color: ${({ theme }) => theme.components.pages.home?.placeOrderFooter?.borderColor};
    color: ${({ theme }) => theme.components.pages.home?.placeOrderFooter?.textColor};
  }

  @media (max-width: 444px) {
    font-size: 0.9rem;
  }
  @media (max-width: 359px) {
    font-size: 0.79rem;
  }
  @media (max-width: 330px) {
    font-size: 0.83rem;
  }
  @media (max-width: 290px) {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    height: 40px;
    font-size: 0.69rem;
  }
  @media (max-width: ${window.innerWidth < 290 ? 289 : 290}px) {
    height: 40px;
    padding-left: 0.15rem;
    padding-right: 0.15rem;
    font-size: 0.59rem;
  }
`;

interface Props {
  hidePriceButton?: boolean;
  isVisible?: boolean;
  onClick?: () => void;
  isDisabled?: boolean;
  primaryButtonText?: string;
  showBackgroundColor?: boolean;
  leftComponent?: JSX.Element;
  isLoading?: boolean;
  hideEstimator?: boolean;
}

const OrderFooter: React.FC<Props> = ({
  hidePriceButton,
  isVisible = true,
  onClick,
  isDisabled,
  primaryButtonText,
  showBackgroundColor,
  leftComponent,
  isLoading = false,
  hideEstimator = false,
}) => {
  const config = useConfig();
  const { t } = useTranslation();
  // handle action when clicking on new order
  const { incrementStep } = useOrderStep();
  const showEstimator = useShowEstimator();

  const showEstimatorTotalOnFooter = config?.showEstimatorTotalOnFooter;

  const showEstimatorTotal = useMemo(
    () => !hideEstimator && showEstimatorTotalOnFooter && showEstimator,
    [showEstimator, showEstimatorTotalOnFooter]
  );

  const handleContinue = () => {
    incrementStep();
  };

  return (
    <Footer showBackgroundColor={showBackgroundColor} isVisible={isVisible}>
      <StyledContainer>
        {!hidePriceButton && !leftComponent && <PricingButtonWithEstimator showEstimatorTotal={showEstimatorTotal} />}
        {leftComponent && leftComponent}
        <StyledPlaceNewOrderListButton
          buttonName={BUTTON_NAMES.CONTINUE}
          disabled={isDisabled}
          block
          size="lg"
          onClick={onClick ?? handleContinue}
          isLoading={isLoading}
        >
          {primaryButtonText ?? t('common.continue')}
        </StyledPlaceNewOrderListButton>
      </StyledContainer>
    </Footer>
  );
};

export default OrderFooter;
